package com.eladfinish.bible.contest.screens.pastQuizzes

import androidx.compose.runtime.Composable
import com.eladfinish.bible.contest.ui.components.WebViewBridge

/** No WebView here, so no voice answers. */
@Composable
actual fun rememberExamVoiceBridge(): WebViewBridge? = null
